import React, { FC } from 'react';
export const Logo: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="125"
      height="33"
      viewBox="0 0 125 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4614 33C13.2146 33 12.9678 32.9377 12.7408 32.8249C12.265 32.6037 11.9313 32.2044 11.8046 31.7439L0.127455 2.28017C-0.232921 1.41889 0.199512 0.414037 1.06442 0.126918C1.92933 -0.231958 2.9384 0.19872 3.22668 1.06001L13.4253 26.7932L23.624 1.06001C23.9844 0.19872 24.9213 -0.231958 25.7862 0.126918C26.6512 0.485794 27.0836 1.41889 26.7232 2.28017L15.0462 31.7437C15.0394 31.7685 15.0319 31.793 15.0239 31.8174C15.0172 31.838 15.01 31.8585 15.0025 31.8788C14.9857 31.9238 14.9668 31.9681 14.946 32.0115C14.9376 32.029 14.9289 32.0463 14.9199 32.0635C14.6625 32.6309 14.0619 33 13.4614 33Z"
        fill="white"
      />
      <path
        d="M52.1667 32.8252C51.69 32.6039 51.3557 32.2038 51.2293 31.7426L42.4356 9.52948C42.0752 8.66819 42.5077 7.66334 43.3726 7.37622C44.2375 7.01734 45.2465 7.44802 45.5349 8.30931L52.8505 26.7888L60.1661 8.30931C60.5264 7.44802 61.4634 7.01734 62.3283 7.37622C63.1932 7.7351 63.6257 8.66819 63.2653 9.52948L54.4856 31.7074C54.4162 32.0095 54.2631 32.2879 54.0428 32.503C53.7392 32.814 53.3129 33 52.8865 33C52.64 33 52.3934 32.9378 52.1667 32.8252Z"
        fill="white"
      />
      <path
        d="M32.7775 31.2774C32.7775 32.2104 33.4983 32.9282 34.4353 32.9282C35.3722 32.9282 36.093 32.2104 36.093 31.2774V8.66819C36.093 7.73512 35.3722 7.01734 34.4353 7.01734C33.4983 7.01734 32.7775 7.73512 32.7775 8.66819V31.2774Z"
        fill="white"
      />
      <path
        d="M95.6271 32.9282H86.3294C82.3653 32.9282 79.1219 29.6983 79.1219 25.7507V14.2666C79.1219 10.319 82.3653 7.08912 86.3294 7.08912H95.6271C96.564 7.08912 97.2848 7.80688 97.2848 8.73994C97.2848 9.67301 96.564 10.3908 95.6271 10.3908H86.3294C84.2392 10.3908 82.5094 12.1134 82.5094 14.1949V25.6789C82.5094 27.7604 84.2392 29.483 86.3294 29.483H95.6271C96.564 29.483 97.2848 30.2008 97.2848 31.1338C97.2848 32.2104 96.564 32.9282 95.6271 32.9282Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.25 32.9282H106.727C104.204 32.9282 102.114 30.8467 102.114 28.3346V22.2337C102.114 19.7215 104.204 17.6401 106.727 17.6401H121.07V14.3384C121.07 12.2569 119.34 10.5343 117.25 10.5343H106.871C105.934 10.5343 105.213 9.81657 105.213 8.8835C105.213 7.95043 105.934 7.23268 106.871 7.23268H117.25C121.214 7.23268 124.457 10.4626 124.457 14.4102V25.8942C124.457 29.6983 121.214 32.9282 117.25 32.9282ZM106.727 29.6266C106.006 29.6266 105.429 29.0523 105.429 28.3346V22.2337C105.429 21.5159 106.006 20.9417 106.727 20.9417H121.07V25.8224C121.07 27.9039 119.34 29.6266 117.25 29.6266H106.727Z"
        fill="white"
      />
      <path
        d="M32.4892 2.63905C32.4892 3.71568 33.3541 4.57699 34.4353 4.57699C35.5164 4.57699 36.3813 3.6439 36.3813 2.63905C36.3813 1.56242 35.5164 0.701133 34.4353 0.701133C33.3541 0.701133 32.4892 1.56242 32.4892 2.63905Z"
        fill="white"
      />
      <path
        d="M71.2657 32.9282C70.3287 32.9282 69.6079 32.2104 69.6079 31.2774V8.66819C69.6079 7.73512 70.3287 7.01734 71.2657 7.01734C72.2026 7.01734 72.9234 7.73512 72.9234 8.66819V31.2774C72.9234 32.2104 72.2026 32.9282 71.2657 32.9282Z"
        fill="white"
      />
      <path
        d="M69.3197 2.63905C69.3197 3.71568 70.1845 4.57699 71.2657 4.57699C72.3468 4.57699 73.2117 3.6439 73.2117 2.63905C73.2117 1.56242 72.3468 0.701133 71.2657 0.701133C70.1845 0.701133 69.3197 1.56242 69.3197 2.63905Z"
        fill="white"
      />
    </svg>
  );
};
